export const SummaryHeadings = {
  TYPE: 'Type',
  HOURS: 'Hours',
};
export const NO_SUMMARY = 'No Summary..';
